import React from 'react';
import PropTypes from 'prop-types';
import { LoadingWrapper, SpinnerElement } from './components/LoadingStyles';

const Loading = ({ size = 'md', color }) => {
  return (
    <LoadingWrapper>
      <SpinnerElement size={size} color={color} />
    </LoadingWrapper>
  );
};

Loading.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.string,
};

Loading.defaultProps = {
  size: 'md',
  color: undefined,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Loading/Loading.jsx